import { curry } from 'fxjs/es';

export const getTabData = curry((key, tab) => {
  return tab.tab_opt.__data__?.[key];
});
